module.exports = __webpack_public_path__ + "img/diamond-4.dbe40585.png";